//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ScrollableContainer from "@Shared/components/general/scrollable-container";
import ReferrerNoteTab from "./referrer-actions-panel/referrer-note-tab.vue";
import ReferrerChecklistTab from "./referrer-actions-panel/referrer-checklist-tab";
import ReferrerFollowUpTab from "./referrer-actions-panel/referrer-follow-up-tab";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ReferrerActionsPanel",
  components: {
    ScrollableContainer,
    ReferrerNoteTab,
    ReferrerChecklistTab,
    ReferrerFollowUpTab
  },
  props: {
    currentTab: {
      type: String,
      required: true
    },
    referrer: {
      type: Object,
      default: () => ({})
    },
    referrerId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      collapsed: false
    };
  },
  computed: {
    tabs() {
      return [{
        name: "note",
        label: this.$t("client-profile.actions.addNote")
      }, {
        name: "checklist",
        label: this.$t("client-profile.actions.createChecklist")
      }, {
        name: "follow-up",
        label: this.$t("client-profile.actions.createActivity")
      }];
    }
  },
  methods: {
    activeItem(tab) {
      return this.currentTab === tab;
    },
    setCurrentTab(tab) {
      this.collapsed = true;
      this.$emit("tab", tab);
    },
    toggleCollapse() {
      this.collapsed = !this.collapsed;
    },
    getCollapseText() {
      const collapseTextMap = {
        note: this.$t("client-profile.actions.takeNotes"),
        checklist: this.$t("client-profile.actions.createAChecklist"),
        "follow-up": this.$t("client-profile.actions.createAnActivity")
      };
      return collapseTextMap[this.currentTab];
    },
    handleSubmit() {
      this.$emit("submit");
    }
  }
});